import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";
import VueEvents from "vue-events";
import VueMask from "di-vue-mask";
import Vue2Filters from "vue2-filters";
import * as Vue2Leaflet from "vue2-leaflet";
import * as uiv from "uiv";
import locale from "uiv/src/locale/lang/pt-BR";
import { router } from "./router/index";
import store from "./vuex/store";
import VueSocketIO from "vue-socket.io";

Vue.component("v-map", Vue2Leaflet.LMap);
Vue.component("v-tilelayer", Vue2Leaflet.LTileLayer);
Vue.component("v-marker", Vue2Leaflet.LMarker);
Vue.component("v-tooltip", Vue2Leaflet.LTooltip);
Vue.component("v-popup", Vue2Leaflet.LPopup);
Vue.component("v-lcircle", Vue2Leaflet.LCircle);

Vue.use(uiv, { locale });
Vue.use(VueEvents);
Vue.use(Vue2Filters);
Vue.use(VueMask);
Vue.use(VueResource);

Vue.http.options.root = "https://gestor.centersattelecom.com.br/";
// Vue.http.options.root = "http://127.0.0.1:3000/";
// Vue.http.options.root = "/";

Vue.http.headers.common["Authorization"] =
    "JWT " + window.localStorage.getItem("token-ips");

// eslint-disable-next-line no-undef,0
const SocketInstance = io.connect(Vue.http.options.root, {
    reconnect: true,
    transports: ["websocket", "polling"]
});

Vue.use(VueSocketIO, SocketInstance);

const menuBar = Vue.component("menu-bar", () =>
    import(/* webpackChunkName: "component_menubar_top" */ "./components/menu.vue")
);

Vue.config.productionTip = true;

new Vue({
    components: {
        menuBar
    },
    router,
    store,
    render: h => h(App)
}).$mount("#app");
